import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { MediaType } from '../typings';
import AddPhotoIcon from '../assets/Photo/icon-add-photo.svg';
import AddMediaIcon from '../assets/Media/icon-add-media.svg';
import { MediaFieldType } from '../utils/mediaFileType';

export const mediaFieldStyles = makeStyles((theme: Theme) =>
  createStyles({
    selectCard: (props: { mediaType: MediaType | MediaFieldType }) => ({
      borderRadius: '4px',
      backgroundColor: '#f1f1f1',
      backgroundImage: `url(${props.mediaType === MediaFieldType.All ? AddMediaIcon : AddPhotoIcon})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      cursor: 'pointer'
    }),
    photoContainer: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr',
      gap: '8px'
    },
    mobilePhotoContainer: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr',
      gap: '4px'
    },
    documentContainer: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '8px',
      [theme.breakpoints.down('md')]: {
        display: 'flex',
        flexDirection: 'column'
      }
    },
    mobileDocumentContainer: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap: '4px'
    },
    documentFileContainer: {
      border: '1px solid #E0E0E0',
      borderRadius: '4px',
      padding: '4px 8px 4px 4px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    addDocumentContainer: {
      border: '0.5px solid #E0E0E0',
      borderRadius: '4px',
      padding: '4px 8px 4px 12px',
      display: 'flex',
      justifyContent: 'space-between',
      backgroundColor: '#F8F8F8',
      alignItems: 'center'
    },
    documentLabelContainer: {
      display: 'flex',
      gap: '8px',
      alignItems: 'center'
    },
    mobileSize: {
      width: '4rem',
      height: '4rem'
    },
    desktopSize: {
      width: '8rem',
      height: '8rem'
    },
    iconSize: {
      width: '1.5rem',
      height: '1.5rem',
      display: 'flex',
      alignItems: 'center'
    },
    documentIconSize: {
      width: '2rem',
      height: '2rem'
    }
  })
);
